"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Profiler", {
    enumerable: true,
    get: function() {
        return Profiler;
    }
});
const _nanoid = require("nanoid");
const _minimatch = require("minimatch");
let Profiler = class Profiler {
    getInfoId() {
        return [
            this.info.id,
            this.info.suffix
        ].filter((k)=>k).join('_');
    }
    log(message) {
        if (this.isEnabled) {
            console.timeLog(this.getInfoId(), message);
        }
    }
    end() {
        if (this.isEnabled) {
            console.timeEnd(this.getInfoId());
        }
    }
    static start(id) {
        return new Profiler({
            id: id,
            suffix: (0, _nanoid.nanoid)(3)
        });
    }
    constructor(info){
        this.info = info;
        this.isEnabled = false;
        if (process.env.ENABLE_PROFILER) {
            for (const enableKey of process.env.ENABLE_PROFILER.split(',')){
                if (enableKey === '*' && !info.id.startsWith('DEBUG:')) {
                    this.isEnabled = true;
                    break;
                } else if ((0, _minimatch.match)([
                    info.id
                ], process.env.ENABLE_PROFILER).length > 0) {
                    this.isEnabled = true;
                    break;
                }
            }
        }
        if (this.isEnabled) {
            console.time(this.getInfoId());
            console.timeLog(this.getInfoId(), 'start');
        }
    }
};
